import { setCategories, setGoals, setInterests, setLifestyleCategories } from '../../slices/dictSlice';
import { baseApi } from './baseApi';

export const dictApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDict: builder.query<{
      goals: any[];
      interests: any[];
      categories: any[];
      lifestyle_categories: any[];
    }, void>({
      query: () => '/dict',
      transformResponse: (res: any) => ({
        goals: res.goals,
        interests: res.interests,
        categories: res.categories,
        lifestyle_categories: res.lifestyle_categories ?? [],
      }),
      providesTags: ['Dict'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setGoals(data.goals));
          dispatch(setInterests(data.categories));
          dispatch(setCategories(data.categories));
          dispatch(setLifestyleCategories(data.lifestyle_categories));
        } catch (error) {
          console.error('Failed to fetch dict:', error);
        }
      },
    }),
  }),
});

export const { useGetDictQuery } = dictApi;
